import { checkPermission } from '../../../utils/auth';
import { P } from '../../../utils/permissions';
import { DASHBOARD_ASSISTANT_RUNTIME_MODE } from '../constants';

export function restrictedResult(area) {
  return {
    runtimeMode: DASHBOARD_ASSISTANT_RUNTIME_MODE,
    status: 'restricted',
    message: `You do not have access to ${area}. You can still use the public CharityStack docs at https://feedback.charitystack.com/docs, or contact an admin for access.`,
  };
}

export function hasPermission(permission) {
  return !permission || checkPermission(permission);
}

export function allowedSearchAreas() {
  return {
    contacts: checkPermission(P.VIEW_CONTACTS),
    payments: checkPermission(P.VIEW_PAYMENTS),
    subscriptions: checkPermission(P.VIEW_SUBSCRIPTIONS),
    forms: checkPermission(P.VIEW_FORMS),
    elements: checkPermission(P.VIEW_ELEMENTS),
  };
}
